import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { IUser } from "app/auth/user.model";
import { Events, NavController, NavParams } from "ionic-angular";
import { Subscription } from "rxjs";
import { NavigationService } from "../../../navigation/navigation.service";

@Component({
  selector: "user-settings-navigation",
  templateUrl: "user-settings-navigation.html",
})
export class UserSettingsNavigation implements OnInit, OnDestroy {
  @Output()
  navigated = new EventEmitter<string>();
  private _activePage: string = "MyAlertsPage";
  subscriptions: Subscription[] = [];
  user: IUser;

  constructor(
    public navCtrl: NavController,
    private navigationService: NavigationService,
    public navParams: NavParams,
    private authSvc: AuthService,
    public events: Events
  ) {
    this.events.subscribe("user:updateorganizations", (user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.user = this.authSvc.getUser();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((val) => val.unsubscribe());
  }

  redirectPage(entity: string) {
    let page = "";

    switch (entity) {
      case "my-alerts":
        page = "MyAlertsPage";
        break;
      default:
        page = "MyAlertsPage";
    }

    this.navigationService.goToInternalPage(page, this.navParams);
  }

  @Input()
  set activePage(value: string) {
    this._activePage = value;
  }

  get activePage(): string {
    return this._activePage;
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-settings/user-settings-navigation/user-settings-navigation.ts